(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bst-header"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  var POP = (window.__bst.popular || []).map(function(s){return s.trim();}).filter(Boolean);
  var SU  = window.__bst.searchUrl || '/search';

  /* ── Desktop elements ── */
  var hdr      = document.getElementById('bst-h');
  var modal    = document.getElementById('bst-sm');
  var bd       = document.getElementById('bst-sm-bd');
  var inp      = document.getElementById('bst-inp');
  var clrBtn   = document.getElementById('bst-clr');
  var smClose  = document.getElementById('bst-sm-x');
  var chips    = document.getElementById('bst-chips');
  var chipsLbl = document.getElementById('bst-chips-lbl');
  var grid     = document.getElementById('bst-grid');
  var va       = document.getElementById('bst-va');
  var vaLnk    = document.getElementById('bst-va-lnk');
  var stEmpty  = document.getElementById('bst-st-empty');
  var stNone   = document.getElementById('bst-st-none');
  var brandsSec  = null;
  var brandsList = null;

  /* ── Mobile drawer elements ── */
  var burger    = document.getElementById('bst-burger');
  var drw       = document.getElementById('bst-drw');
  var drwBd     = document.getElementById('bst-drw-bd');
  var drwX      = document.getElementById('bst-drw-x');
  var drwInp    = document.getElementById('bst-drw-inp');
  var drwClr    = document.getElementById('bst-drw-clr');
  var drwGrid   = document.getElementById('bst-drw-grid');
  var drwVa     = document.getElementById('bst-drw-va');
  var drwVaLnk  = document.getElementById('bst-drw-va-lnk');
  var drwStEmpty = document.getElementById('bst-drw-st-empty');
  var drwStNone  = document.getElementById('bst-drw-st-none');

  var open   = false;
  var raf    = null;
  var drwRaf = null;
  var ctrl   = null;

  /* ── Helpers ── */
  function isMobile() { return window.innerWidth < 750; }

  function money(c) {
      if (c == null) return '';
      var n = parseFloat(c);
      if (isNaN(n)) return '';
      return n.toFixed(2).replace('.',',') + '\u00a0€';
  }
  function disc(p, cp) {
      p = parseFloat(p)||0; cp = parseFloat(cp)||0;
      if (!cp || cp <= p) return null;
      return Math.round((1 - p/cp)*100);
  }
  /* Scroll shadow only — auto-hide is handled by the standalone <script> after the markup. */
  window.addEventListener('scroll', function(){
    if (hdr) hdr.classList.toggle('scrolled', window.scrollY > 4);
  }, {passive: true});

  /* ── Position desktop modal ── */
  function pos() {
    if (!hdr || !modal) return;
    var rect   = hdr.getBoundingClientRect();
    var bottom = Math.round(rect.bottom);
    modal.style.top      = bottom + 'px';
    modal.style.maxHeight = (window.innerHeight - bottom - 12) + 'px';
  }
  window.addEventListener('scroll', pos, {passive: true});
  window.addEventListener('resize', pos, {passive: true});
  pos();

  /* ── Desktop modal open/close ── */
  function openModal() {
    if (open) return;
    open = true;
    pos();
    modal.classList.add('on');
    modal.setAttribute('aria-hidden','false');
    bd.classList.add('on');
    inp && inp.setAttribute('aria-expanded','true');
    if (!inp || inp.value.trim().length < 1) {
      reset();
      mkChips(POP, false);
    }
  }

  function closeModal() {
    if (!open) return;
    open = false;
    modal.classList.remove('on');
    modal.setAttribute('aria-hidden','true');
    bd.classList.remove('on');
    inp && inp.setAttribute('aria-expanded','false');
    activeFilter = null;
    document.querySelectorAll('.bst-sm-filter.is-active').forEach(function(b) {
      b.classList.remove('is-active');
      b.setAttribute('aria-pressed', 'false');
    });
  }

  /* ── Desktop input events ── */
  if (inp) {
    inp.addEventListener('focus', function() {
      if (inp.value.trim().length > 0) openModal();
    });

    inp.addEventListener('input', function() {
      if (raf) cancelAnimationFrame(raf);
      raf = requestAnimationFrame(function() {
        var q = inp.value;
        clrBtn && clrBtn.classList.toggle('on', q.length > 0);
        if (q.trim().length > 0) { openModal(); fetch2(q); }
        else { closeModal(); }
      });
    });

    inp.addEventListener('keydown', function(e) {
      if (e.key === 'Escape') { closeModal(); inp.blur(); return; }
      if (e.key === 'Enter' && inp.value.trim()) {
        e.preventDefault();
        window.location.href = SU + '?q=' + encodeURIComponent(inp.value.trim()) + '&type=product';
      }
    });
  }

  if (clrBtn) {
    clrBtn.addEventListener('click', function() {
      if (inp) inp.value = '';
      clrBtn.classList.remove('on');
      closeModal();
    });
  }

  if (smClose) {
    smClose.addEventListener('click', function() {
      if (inp) { inp.value = ''; clrBtn && clrBtn.classList.remove('on'); }
      closeModal();
    });
  }

  if (bd) { bd.addEventListener('click', closeModal); }

  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && open) closeModal();
  });

  function isOutside(e) {
    if (!open) return false;
    var path = (e.composedPath && e.composedPath()) || [e.target];
    var inModal  = modal && path.some(function(n){ return n === modal; });
    var inHeader = hdr   && path.some(function(n){ return n === hdr;   });
    var inBd     = bd    && path.some(function(n){ return n === bd;    });
    return !inModal && !inHeader && !inBd;
  }
  document.addEventListener('pointerdown', function(e){ if (isOutside(e)) closeModal(); }, true);
  document.addEventListener('click',       function(e){ if (isOutside(e)) closeModal(); }, true);

  /* ── Desktop states ── */
  function reset(s) {
    stEmpty.classList.toggle('on', s === 'empty' || s === undefined);
    stNone.classList.toggle('on', s === 'none');
    if (s !== 'results') {
      grid.innerHTML = '';
      va.style.display = 'none';
    }
  }

  /* ── Desktop chips ── */
  function mkChips(terms, isQ) {
    chips.innerHTML = '';
    chipsLbl.textContent = isQ ? 'Suggestions :' : 'Recherches populaires :';
    terms.slice(0, 8).forEach(function(t) {
      var b = document.createElement('button');
      b.type = 'button'; b.className = 'bst-sm-chip';
      b.setAttribute('role','listitem'); b.textContent = t;
      b.addEventListener('click', function(){
        inp.value = t; clrBtn.classList.add('on'); fetch2(t);
      });
      chips.appendChild(b);
    });
  }

  /* ── Desktop render ── */
  function render(products) {
    grid.innerHTML = '';
    if (!products || !products.length) { reset('none'); return; }
    reset('results');
    va.style.display = '';
    products.forEach(function(p) {
      var d   = disc(p.price, p.compare_at_price);
      var img = p.featured_image ? (typeof p.featured_image==='string' ? p.featured_image : p.featured_image.url) : null;
      var a = document.createElement('a');
      a.className = 'bst-sm-card'; a.href = p.url;
      a.setAttribute('role','listitem'); a.setAttribute('aria-label', p.title);
      var iw = document.createElement('div'); iw.className = 'bst-sm-card__img';
      if (img) {
        var el = document.createElement('img');
        el.src = img.replace(/(\.\w+)(\?.*)?$/,'_400x400$1$2');
        el.alt = p.title; el.width = 400; el.height = 400; el.loading = 'lazy';
        iw.appendChild(el);
      }
      if (!p.available) {
        var ob = document.createElement('span');
        ob.className = 'bst-sm-card__bdg bst-sm-card__bdg--oos'; ob.textContent = 'Rupture'; iw.appendChild(ob);
      } else if (d) {
        var db = document.createElement('span');
        db.className = 'bst-sm-card__bdg'; db.textContent = '-' + d + '%'; iw.appendChild(db);
      }
      a.appendChild(iw);
      var info = document.createElement('div'); info.className = 'bst-sm-card__info';
      var nm = document.createElement('p'); nm.className = 'bst-sm-card__name'; nm.textContent = p.title;
      info.appendChild(nm);
      var pr = document.createElement('div'); pr.className = 'bst-sm-card__prices';
      var sl = document.createElement('span'); sl.className = 'bst-sm-card__sale'; sl.textContent = money(p.price);
      pr.appendChild(sl);
      if (p.compare_at_price && parseInt(p.compare_at_price) > parseInt(p.price)) {
        var og = document.createElement('span'); og.className = 'bst-sm-card__orig'; og.textContent = money(p.compare_at_price);
        pr.appendChild(og);
      }
      info.appendChild(pr); a.appendChild(info); grid.appendChild(a);
    });
  }

  /* ── Mobile drawer states ── */
  function resetDrw(s) {
    drwStEmpty.classList.toggle('on', s === 'empty' || s === undefined);
    drwStNone.classList.toggle('on', s === 'none');
    if (s !== 'results') {
      drwGrid.innerHTML = '';
      drwVa.style.display = 'none';
    }
  }

  /* ── Mobile drawer render — horizontal cards stacked vertically ── */
  function renderDrw(products) {
    drwGrid.innerHTML = '';
    if (!products || !products.length) { resetDrw('none'); return; }
    resetDrw('results');
    drwVa.style.display = '';
    products.forEach(function(p) {
      var d   = disc(p.price, p.compare_at_price);
      var img = p.featured_image ? (typeof p.featured_image==='string' ? p.featured_image : p.featured_image.url) : null;
      var a = document.createElement('a');
      a.className = 'bst-drw__card'; a.href = p.url;
      a.setAttribute('role','listitem'); a.setAttribute('aria-label', p.title);
      /* Thumbnail */
      var iw = document.createElement('div'); iw.className = 'bst-drw__card__img';
      if (img) {
        var el = document.createElement('img');
        el.src = img.replace(/(\.\w+)(\?.*)?$/,'_120x120$1$2');
        el.alt = p.title; el.loading = 'lazy';
        iw.appendChild(el);
      }
      a.appendChild(iw);
      /* Info */
      var info = document.createElement('div'); info.className = 'bst-drw__card__info';
      var nm = document.createElement('p'); nm.className = 'bst-drw__card__name'; nm.textContent = p.title;
      info.appendChild(nm);
      var pr = document.createElement('div'); pr.className = 'bst-drw__card__prices';
      var sl = document.createElement('span'); sl.className = 'bst-drw__card__sale'; sl.textContent = money(p.price);
      pr.appendChild(sl);
      if (p.compare_at_price && parseInt(p.compare_at_price) > parseInt(p.price)) {
        var og = document.createElement('span'); og.className = 'bst-drw__card__orig'; og.textContent = money(p.compare_at_price);
        pr.appendChild(og);
      }
      info.appendChild(pr);
      /* Badge */
      if (!p.available) {
        var ob = document.createElement('span');
        ob.className = 'bst-drw__card__bdg bst-drw__card__bdg--oos'; ob.textContent = 'Rupture';
        info.appendChild(ob);
      } else if (d) {
        var db = document.createElement('span');
        db.className = 'bst-drw__card__bdg'; db.textContent = '-' + d + '%';
        info.appendChild(db);
      }
      a.appendChild(info);
      drwGrid.appendChild(a);
    });
  }

  /* ── Shared fetch ── */
  function fetchResults(q, onProducts, onQueries) {
    if (ctrl) { try { ctrl.abort(); } catch(e){} }
    ctrl = typeof AbortController !== 'undefined' ? new AbortController() : null;
    var url = '/search/suggest.json'
      + '?q=' + encodeURIComponent(q)
      + '&resources[type]=product,query,collection'
      + '&resources[limit]=8'
      + '&resources[options][unavailable_products]=last';
    fetch(url, ctrl ? {signal: ctrl.signal} : {})
      .then(function(r){ return r.json(); })
      .then(function(d){
        var res   = (d.resources && d.resources.results) || {};
        var prods = res.products || [];
        var qrys  = (res.queries||[]).map(function(x){ return x.text||x.styled_text||''; }).filter(Boolean);
        onProducts(prods);
        if (onQueries) onQueries(qrys);
      })
      .catch(function(e){ if (e && e.name==='AbortError') return; });
  }

  /* ── Desktop fetch ── */
  function fetch2(q) {
    q = (q||'').trim();
    if (vaLnk) vaLnk.href = SU + '?q=' + encodeURIComponent(q) + '&type=product';
    if (q.length < 1) { reset('empty'); mkChips(POP, false); return; }
    fetchResults(q, render, function(qrys){
      mkChips(qrys.length ? qrys : POP, !!qrys.length);
    });
  }

  /* ── Mobile fetch → renders into drawer ── */
  function fetch2drw(q) {
    q = (q||'').trim();
    if (drwVaLnk) drwVaLnk.href = SU + '?q=' + encodeURIComponent(q) + '&type=product';
    if (q.length < 1) { resetDrw('empty'); return; }
    fetchResults(q, renderDrw, null);
  }

  /* ── Drawer input events ── */
  if (drwInp) {
    drwInp.addEventListener('input', function() {
      if (drwRaf) cancelAnimationFrame(drwRaf);
      drwRaf = requestAnimationFrame(function() {
        var q = drwInp.value;
        drwClr && drwClr.classList.toggle('on', q.length > 0);
        if (q.trim().length > 0) fetch2drw(q);
        else resetDrw('empty');
      });
    });
    drwInp.addEventListener('keydown', function(e) {
      if (e.key === 'Enter' && drwInp.value.trim()) {
        e.preventDefault();
        window.location.href = SU + '?q=' + encodeURIComponent(drwInp.value.trim()) + '&type=product';
      }
    });
  }

  if (drwClr) {
    drwClr.addEventListener('click', function() {
      if (drwInp) drwInp.value = '';
      drwClr.classList.remove('on');
      resetDrw('empty');
    });
  }

  /* ── Mobile drawer open/close ── */
  if (burger) burger.addEventListener('click', function(){
    drw.classList.add('on'); drwBd.classList.add('on');
    burger.setAttribute('aria-expanded','true');
    setTimeout(function(){ drwInp && drwInp.focus(); }, 300);
  });

  function closeDrw() {
    drw.classList.remove('on'); drwBd.classList.remove('on');
    if (burger) burger.setAttribute('aria-expanded','false');
  }
  if (drwX)  drwX.addEventListener('click', closeDrw);
  if (drwBd) drwBd.addEventListener('click', closeDrw);

  /* ── Desktop category filter buttons ── */
  var activeFilter = null;
  function wireFilters() {
    document.querySelectorAll('.bst-sm-filter').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var label = btn.getAttribute('data-label') || '';
        if (activeFilter === label) {
          activeFilter = null;
          btn.classList.remove('is-active'); btn.setAttribute('aria-pressed','false');
          fetch2(inp ? inp.value.trim() : '');
        } else {
          document.querySelectorAll('.bst-sm-filter.is-active').forEach(function(b){
            b.classList.remove('is-active'); b.setAttribute('aria-pressed','false');
          });
          activeFilter = label;
          btn.classList.add('is-active'); btn.setAttribute('aria-pressed','true');
          var combined = (inp && inp.value.trim()) ? inp.value.trim() + ' ' + label : label;
          fetch2(combined);
        }
      });
    });
  }
  wireFilters();

  /* ── Wishlist badge ── */
  function updateWishlistBadge() {
    var bdg = document.querySelector('[data-count-wishlist]');
    if (!bdg) return;
    var list = [];
    try { list = JSON.parse(localStorage.getItem('bst-wishlist')) || []; } catch(e) {}
    var n = Array.isArray(list) ? list.length : 0;
    bdg.textContent = n;
    bdg.style.display = n > 0 ? '' : 'none';
  }

  /* Patch localStorage.setItem to fire a same-tab event for bst-wishlist */
  (function() {
    var _set = localStorage.setItem.bind(localStorage);
    localStorage.setItem = function(key, value) {
      _set(key, value);
      if (key === 'bst-wishlist') {
        window.dispatchEvent(new CustomEvent('bst:wishlist:change', { detail: { value: value } }));
      }
    };
  })();

  window.addEventListener('bst:wishlist:change', updateWishlistBadge);

  /* ── Cart badge ── */
  function updateCartBadge(n) {
    var bdg = document.getElementById('bst-cart-count');
    if (!bdg) return;
    /* Re-enforce our class in case any theme script stripped it */
    if (!bdg.classList.contains('bst-h-icon__bdg')) bdg.classList.add('bst-h-icon__bdg');
    bdg.removeAttribute('style');
    bdg.textContent = n;
    bdg.style.display = n > 0 ? '' : 'none';
  }

  function fetchCartCount() {
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function(r) { return r.json(); })
      .then(function(d) { updateCartBadge(d.item_count || 0); })
      .catch(function() {});
  }

  /* Guard against theme scripts mutating the badge after we set it */
  (function() {
    var bdg = document.getElementById('bst-cart-count');
    if (!bdg || typeof MutationObserver === 'undefined') return;
    var guard = false;
    new MutationObserver(function() {
      if (guard) return;
      guard = true;
      fetchCartCount();
      setTimeout(function() { guard = false; }, 200);
    }).observe(bdg, { attributes: true, childList: true, characterData: true });
  })();

  /* Cart events — covers native Shopify AJAX + most theme SDKs */
  document.addEventListener('cart:updated',      function(e) { updateCartBadge((e.detail && e.detail.cart && e.detail.cart.item_count) || 0); });
  document.addEventListener('cart:refresh',      fetchCartCount);
  document.addEventListener('theme:cart:change', fetchCartCount);
  /* T4S / Dawn custom events */
  document.addEventListener('t4s:cart:update',   fetchCartCount);
  document.addEventListener('CartUpdate',        fetchCartCount);

  /* ── Init ── */
  mkChips(POP, false);
  resetDrw('empty');
  updateWishlistBadge();
  fetchCartCount();
  window.addEventListener('storage', function(e) {
    if (e.key === 'bst-wishlist') updateWishlistBadge();
  });
  document.addEventListener('shopify:section:load', function(){ pos(); mkChips(POP, false); wireFilters(); resetDrw('empty'); updateWishlistBadge(); fetchCartCount(); });

})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
